import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

export interface TabulatedFormTab {
  id: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-tabulated-form',
  standalone: false,
  templateUrl: './tabulated-form.html',
  styleUrl: './tabulated-form.scss',
})
export class TabulatedForm {
  @Input() tabs: TabulatedFormTab[] = [];
  @Input() activeTab = '';
  @Output() activeTabChange = new EventEmitter<string>();

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  selectTab(tab: TabulatedFormTab): void {
    if (tab.disabled) {
      return;
    }
    this.activeTab = tab.id;
    this.host.nativeElement.querySelectorAll<HTMLElement>('[data-tab-id]').forEach((panel) => {
      const active = panel.dataset['tabId'] === tab.id;
      panel.hidden = !active;
      panel.classList.toggle('active', active);
      panel.classList.toggle('show', active);
    });
    this.activeTabChange.emit(tab.id);
  }
}
